import AxiosClient from "@/config/axios/AxiosConfig";
import { MailCalculationRequest } from "@/interfaces/MailCalculationRequest";

export function getTranslations(locale?: string): Promise<any> {
  let requestUri = "/calculation/gettranslations";
  if (locale) {
    requestUri += `?locale=${locale}`;
  }
  return AxiosClient.get(requestUri);
}

export function getCarSizes(locale?: string): Promise<any> {
  let requestUri = "/calculation/getcarsizes";
  if (locale) {
    requestUri += `?locale=${locale}`;
  }
  return AxiosClient.get(requestUri);
}

export function getSubscription(kilometersPerYear: number, locale?: string): Promise<any> {
  let requestUri = `/calculation/getsubscription?kilometersPerYear=${kilometersPerYear}`;
  if (locale) {
    requestUri += `&locale=${locale}`;
  }
  return AxiosClient.get(requestUri);
}

export function mailCalculation(request: MailCalculationRequest): Promise<any> {
  return AxiosClient.post("/calculation/mailcalculate", request);
}

export function calculate(
  carSize: string,
  isElectric: boolean,
  kilometersPerYear: number,
  locale: string
): Promise<any> {
  let requestUri = `/calculation/calculate?carSize=${carSize}&isElectric=${isElectric}&kilometersPerYear=${kilometersPerYear}`;
  if (locale) {
    requestUri += `&locale=${locale}`;
  }
  return AxiosClient.get(requestUri);
}
